import {
  selectedCheckIcon,
  selectedWarningIcon,
  unselectedCheckIcon,
  unselectedWarningIcon,
} from '@/assets/images/icons';
import { IssuesCategoryType } from '@/stores/AccessibilityCheckerStore/AccessibilityChecker.consts';

export type SelectedIssueProps = {
  categoryType: IssuesCategoryType;
};

export const CategoryIconsDic: Record<string, Record<string, string>> = {
  has_issues: {
    selected: selectedWarningIcon,
    unselected: unselectedWarningIcon,
  },
  no_issues: {
    selected: selectedCheckIcon,
    unselected: unselectedCheckIcon,
  },
};

export type IssuesAmountProps = {
  issuesAmount: number;
};
